import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Login from "./pages/Login";
import VerifyCode from "./pages/VerifyCode";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Users from "./pages/Users";
import TimeTracking from "./pages/TimeTracking";
import Projects from "./pages/Projects";
import Assing from "./pages/Assign";
import Files from "./pages/Files";
import Comments from "./pages/Comments";
import Settings from "./pages/Settings";
import Notifications from "./pages/Notifications";
import UserLayout from "./layouts/UserLayout";
import AdminLayout from "./layouts/AdminLayout";
import MyTime from "./pages/MyTime";
import ProtectedRoute from "./components/ProtectedRoute";
import Tasks from "./pages/Tasks";

function AnimatedRoutes() {
  // const token = localStorage.getItem("token");
  // const role = localStorage.getItem("role");

  const location = useLocation();
  const [fadeClass, setFadeClass] = useState("");

  useEffect(() => {
    setFadeClass("page-fade");

    const timeout = setTimeout(() => {
      setFadeClass("");
    }, 400);

    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return (
    <div className={fadeClass}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify" element={<VerifyCode />} />

        <Route
          path="/user/dashboard"
          element={
            <ProtectedRoute allowedRole="user">
              <UserLayout>
                <Dashboard />
              </UserLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/projects"
          element={
            <ProtectedRoute allowedRole="user">
              <UserLayout>
                <Projects />
              </UserLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/my-time"
          element={
            <ProtectedRoute allowedRole="user">
              <UserLayout>
                <MyTime />
              </UserLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/files"
          element={
            <ProtectedRoute allowedRole="user">
              <UserLayout>
                <Files />
              </UserLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/tasks"
          element={
            <ProtectedRoute allowedRole="user">
              <UserLayout>
                <Tasks />
              </UserLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/comments"
          element={
            <ProtectedRoute allowedRole="user">
              <UserLayout>
                <Comments />
              </UserLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/settings"
          element={
            <ProtectedRoute allowedRole="user">
              <UserLayout>
                <Settings />
              </UserLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/user/notifications"
          element={
            <ProtectedRoute allowedRole="user">
              <UserLayout>
                <Notifications />
              </UserLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminLayout>
                <AdminDashboard />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminLayout>
                <Users />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/my-time"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminLayout>
                <MyTime />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/projects"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminLayout>
                <Projects />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/assing-projects"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminLayout>
                <Assing />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/time-tracking"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminLayout>
                <TimeTracking />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/files"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminLayout>
                <Files />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/tasks"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminLayout>
                <Tasks />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/comments"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminLayout>
                <Comments />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settings"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminLayout>
                <Settings />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/notifications"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminLayout>
                <Notifications />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AnimatedRoutes />
    </Router>
  );
}

export default App;
